import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';


@Component({
  selector: 'app-first-login',
  templateUrl: './first-login.component.html',
  styleUrls: ['./first-login.component.scss'],
})
export class FirstLoginComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
    const cu = JSON.parse(localStorage.getItem('currentUser'));
    if (!cu.first_login) {
      this.router.navigate(['/']);
    }
  }


}
